import {
	AfterViewInit,
	ChangeDetectorRef,
	Directive,
	ElementRef,
	HostListener,
	OnDestroy
} from '@angular/core';

@Directive({
	selector: '[eaFocusTrap]'
})
export class FocusTrapDirective implements AfterViewInit, OnDestroy {
	private focusableElements: HTMLElement[] = [];
	private firstElement: HTMLElement;
	private lastElement: HTMLElement;
	private observer: MutationObserver;

	constructor(
		private el: ElementRef,
		private cdr: ChangeDetectorRef
	) {}

	@HostListener('keydown', ['$event'])
	onKeyDown(event: KeyboardEvent) {
		if (event.key === 'Tab') {
			if (event.shiftKey && document.activeElement === this.firstElement) {
				event.preventDefault();
				this.lastElement.focus();
			} else if (
				!event.shiftKey &&
				document.activeElement === this.lastElement
			) {
				event.preventDefault();
				this.firstElement.focus();
			}
		}
	}

	ngAfterViewInit() {
		this.loadFocusableElements();

		this.observer = new MutationObserver(() => {
			this.loadFocusableElements();
			this.cdr.detectChanges();
		});

		this.observer.observe(this.el.nativeElement, {
			childList: true,
			subtree: true
		});
	}

	ngOnDestroy() {
		if (this.observer) {
			this.observer.disconnect();
		}
	}

	private loadFocusableElements() {
		this.focusableElements = Array.from(
			this.el.nativeElement.querySelectorAll(
				'a, button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
			)
		);

		if (this.focusableElements.length) {
			this.firstElement = this.focusableElements[0];
			this.lastElement =
				this.focusableElements[this.focusableElements.length - 1];
		}
	}
}
